"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DELETE_ADDRESS_DATA = exports.CREATE_ADDRESS_DATA = exports.UPDATE_ADDRESS_DATA = void 0;
// eslint-disable-next-line import/prefer-default-export
exports.UPDATE_ADDRESS_DATA = 'UPDATE_ADDRESS_DATA';
exports.CREATE_ADDRESS_DATA = 'CREATE_ADDRESS_DATA';
exports.DELETE_ADDRESS_DATA = 'DELETE_ADDRESS_DATA';
